import { render, staticRenderFns } from "./FsmDetail.vue?vue&type=template&id=9f2c70b4"
import script from "./FsmDetail.vue?vue&type=script&lang=js"
export * from "./FsmDetail.vue?vue&type=script&lang=js"
import style0 from "./FsmDetail.vue?vue&type=style&index=0&id=9f2c70b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports